import React, { PureComponent } from 'react'
import styled from 'styled-components'
import getFont from '../../helpers/fonts/fonts'
import getPalette, { IPalette } from '../../helpers/colors/colors'

const colors: IPalette = getPalette()

const Wrapper = styled.div<{ disabled?: boolean }>`
	width: 50px;
	height: 24px;
	background: ${colors.iron};
	border: 1px solid ${colors.submarine};
	border-radius 30px;
	cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
	opacity: ${(props) => (props.disabled ? 0.5 : 1)};
	overflow: hidden;
	position: relative;
	transform: translateZ(0);
`

const Label = styled.span`
	color: ${colors.white};
	font-family: ${getFont('primaryHeavy')};
	font-size: 8px;
	position: absolute;
	top: 8px;
	right: 6px;
	text-transform: uppercase;
`

const TogglerBar = styled.div`
	width: 50px;
	height: 24px;
	background: ${colors.blue};
	transition: ease-in-out 0.2s left;
	position: absolute;
	left: 0;
	border-radius: 30px;

	&.togglerOff {
		left: -28px;
	}
`

const ToggleOnLabel = styled.span`
	color: ${colors.white};
	font-family: ${getFont('primaryMedium')};
	font-size: 8px;
	position: absolute;
	top: 8px;
	left: 9px;
	text-transform: uppercase;
`

const TogglerCircle = styled.div`
	width: 24px;
	height: 24px;
	background: ${colors.white};
	border: 1px solid ${colors.submarine};
	border-radius 30px;
	position: absolute;
	top: -1px;
	right: -1px;
`

interface IToggleProps {
	onChange: (value: string) => void
	value: string
	disabled?: boolean
}

class Toggle extends PureComponent<IToggleProps> {
	static defaultProps = {
		value: '0',
		disabled: false,
	}

	onClick = () => {
		if (!this.props.disabled) {
			this.props.onChange(this.props.value === '0' ? '1' : '0')
		}
	}

	render() {
		return (
			<Wrapper onClick={this.onClick} disabled={this.props.disabled}>
				<Label>Off</Label>
				<TogglerBar className={this.props.value === '0' ? 'togglerOff' : ''}>
					<ToggleOnLabel>On</ToggleOnLabel>
					<TogglerCircle />
				</TogglerBar>
			</Wrapper>
		)
	}
}

export default Toggle
